<div class="container text-center px-3 py-3 pt-md-5 pb-md-4 mx-auto">
  <h1 class="mb-3">Confirmación de suscripción</h1>

  <div *ngIf="this.loading" class="text-center">
    Cargando...
  </div>

  <div *ngIf="!this.loading && this.plan" class="row">
    <div class="col-md-6 col-lg-4 order-md-2">
      <div class="card">
        <div class="card-header">
          Medio de pago asociado
        </div>
        <div class="card-body text-justify">
          <p *ngIf="!this.meanOfPaymentData || (this.meanOfPaymentData && !this.meanOfPaymentData.UsuarioMedioPagoActivo && !this.meanOfPaymentData.UsuarioMedioPagoPendiente)" class="card-text">
            No tiene un medio de pago asociado, deberá ingresar los datos de la tarjeta al momento de pagar.
          </p>
          <p *ngIf="this.meanOfPaymentData && this.meanOfPaymentData.UsuarioMedioPagoPendiente" class="card-text">
            Su medio de pago se encuentra en proceso de aprobación.
          </p>
          <div *ngIf="this.meanOfPaymentData && this.meanOfPaymentData.UsuarioMedioPagoActivo">
            <div id="meanOfPaymentDataContainer">
              <span id="meanOfPaymentImage" *ngIf="this.meanOfPaymentData.UsuarioMedioPagoImagen">
                <img [src]="this.meanOfPaymentData.UsuarioMedioPagoImagen">
              </span>
              <span id="meanOfPaymentIssuer">
                {{this.meanOfPaymentData.UsuarioMedioPagoIssuer ? this.meanOfPaymentData.UsuarioMedioPagoIssuer : ''}}
              </span>
              <span id="meanOfPaymentCreditCard">
                {{this.meanOfPaymentData.UsuarioMedioPagoNombre ? this.meanOfPaymentData.UsuarioMedioPagoNombre : 'XXXX XXXX XXXX XXXX'}}
              </span>
              <span id="meanOfPaymentExpirationDate" *ngIf="this.meanOfPaymentData.UsuarioMedioPagoExpiracion">
                {{this.meanOfPaymentData.UsuarioMedioPagoExpiracion | date: 'MM/yy'}}
              </span>
            </div>             
          </div>          
        </div>
        <div *ngIf="this.meanOfPaymentData && this.meanOfPaymentData.UsuarioMedioPagoActivo">
          <div class="card-footer">
            <button type="button" class="use-app-colors btn btn-lg btn-block btn-primary" (click)="this.changeMeanOfPayment(plan.PlanId)">Cambiar medio de pago</button>
          </div> 
        </div>
      </div>
    </div>

    <div class="col-md-6 col-lg-8 mt-3 mt-md-0 order-md-1">
      <div class="card">
        <div class="card-header">
          Plan seleccionado
        </div>
        <div class="card-body">
          <div class="mb-3" [innerHTML]="'<b>'+plan.PlanName+'</b>'"></div>
          <h1 class="card-title pricing-card-title">
            ${{plan.PlanPrice}}
            <br>
            <!--<small class="text-muted">{{plan.PlanFrequency}}</small>-->
          </h1>
          <div class="mt-3 mb-4" [innerHTML]="plan.PlanDescription"></div>
        </div>
        <div *ngIf="!plan.LoggedInUserHasPlan && (!this.meanOfPaymentData || (this.meanOfPaymentData && !this.meanOfPaymentData.UsuarioMedioPagoPendiente))" class="card-footer">
          <button type="button" class="use-app-colors btn btn-lg btn-block btn-primary" (click)="this.subscribeToPlan(plan.PlanId)">Pagar</button>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="this.error" [innerHTML]="this.error" class="errors-container mt-3 alert alert-danger" role="alert"></div>
  <div *ngIf="this.message" [innerHTML]="this.message" class="messages-container mt-3 alert alert-success" role="alert"></div>
  <div *ngIf="this.alert" [innerHTML]="this.alert" class="messages-container mt-3 alert alert-warning" role="alert"></div>
</div>
